module.exports = __webpack_public_path__ + "static/img/star.d73c50df.png";